if(setProductsParsed != '') {
	var setProductId = ''
	// Grabbing product thumbnails
	// Covers: Editions, Launchpad Star, Lookbook, Kickstand, Startup, Simple, Radiance, Minimal, Supply, New Standard and many more.
	var thumbnails = jQuery('.product__thumbs img')
	var baseTitle = setProductsParsed[0].title
	var getOptions = setProductsParsed[0].options
	if(getOptions != undefined) {
		var getOptionsCount = getOptions.length
	} else {
		var getOptionsCount = ''
	}

	var getVariants = setProductsParsed[0].variants
    //console.log('getVariants')
    //console.log(getVariants)
    
    //console.log('setCollections')
  	//console.log(setCollections)
} else {
	var setProductsParsed = ''
}

jQuery(function() {
  //special function for discount prices
  handleDiscountedPrices()
  setTimeout('handleDiscountedPrices()',500)
  setTimeout('handleDiscountedPrices()',1500)
  setTimeout('handleDiscountedPrices()',2500)

    //PIMZ-299 sort disabled colors to the end
    jQuery(".variant-input-wrap[name='Color'] .variant-input .disabled").parent().insertAfter($(".variant-input-wrap[name='Color']  .variant-input:last"));
  
  	//added the currentactiveprice to product-template
   	var price = jQuery('.currentactiveprice').text()
    price = jQuery.trim(price)
    price = price.replace('$','');
    price = parseInt(price)

    //console.log('price '+price);
    if(price == 0) {
      jQuery('.currentactiveprice').text('Currently Unavailable').show()
      jQuery('.product__policies').hide();
    } else {
      jQuery('.currentactiveprice').show()
      jQuery('.product__policies').show();
    };

	if(setProductsParsed != '') {
		reorderMattresses();
		//console.log('!!!!!!sortOutOptionLoad on start')
		sortOutOptionLoad();

		jQuery('.variant-input-wrap').on('change', '.variant-input input', function() {
			console.log('sortOutOptionLoad on change')
			sortOutOptionLoad();
			sortOutOptionDisable(jQuery(this).val(),jQuery(this).attr('data-option'));

		});
	}

	//PIMS-3532 forcing product titles to be the same height
	setheight()
	$(window).resize(function() {
		setheight()
	});

 	handleSingleVariantDisplay()

	// help out page location on newsletter signup
	var currenturl = window.location.href;
	if (currenturl.indexOf('/challenge') > -1) {
		setTimeout('$("html, body").animate({ scrollTop: 0 }, 700, "swing", function () {});',1500)
	}
	if (currenturl.indexOf('customer_posted=true') > -1) {
		setTimeout('$("html, body").animate({ scrollTop: '+$(document).height()+' }, 700, "swing", function () {});',1500) 
	}
  
  //check for if all are disabled
  var colorswatchcount = jQuery('.color-swatch').length
  var colorswatchcountdisabled = jQuery('.color-swatch.disabled').length
  if(colorswatchcount == colorswatchcountdisabled) {
    jQuery('.disabled').show()
  }
  
  //PARTY-299 breadcrumbs
  var referrer = document.referrer;
  var referringcollection = ''
  console.log('referrer')

  if(referrer.indexOf('collections/') > -1) {
    referringcollection = referrer.split('.com')[1]
  }
  if(referringcollection.indexOf('?') > -1) {
    referringcollection = referringcollection.split('?')[0]
  }
  console.log(referringcollection)
  
  breadCrumbGen(referringcollection)

//https://dorelhome.atlassian.net/browse/PARTY-526
//if colors and sizes... when a color has no size available disable it
  var optionsInventory = []
  jQuery(setVariants).each(function(i,detail) {
      var color = detail.color
      var inventory = jQuery('.variant-input[data-value="'+color+'"]').attr('data-inventory')
    if(inventory == undefined) {
      var newinventory = detail.inventory
    } else {
        var newinventory = parseInt(inventory) + parseInt(detail.inventory)
    }
    
   jQuery('.variant-input[data-value="'+color+'"]').attr('data-inventory',newinventory)
    if(newinventory > 0) {
      jQuery('.variant-input[data-value="'+color+'"] input, .variant-input[data-value="'+color+'"] label').removeClass('disabled')
    }
  });

  //hide any with no inventory
  jQuery('.variant-input[data-inventory="0"]').each(function() {
      //but allow it to be shown IF it's the default or loaded by the user directly
    if(jQuery(this).find('input').is(':checked')) {
      jQuery(this).show()
    } else {
      jQuery(this).hide()
    }
  })
  
});

function handleDiscountedPrices() {
   //if we have a discounted price, be sure to hide the on sale price and make the discounted price red
    if(jQuery('.discountedpricepp').length > 0 && jQuery('.discountedpricepp').text() != '') {
      console.log ('**hide mixed up prices')
      //jQuery('.onsaleinline').text(jQuery('.discountedpricepp').text())
      jQuery('.discountedpricepp').css('font-size','15px !important').attr('style','font-size:15px !important;')
       jQuery('.gspriceorgprice').removeClass('hide')
    
      jQuery('.onsaleinline').addClass('discountedpriceppmodified')
      jQuery('.product__price').show().attr('style','margin-right: 5px;float: left;color: gray;text-decoration: line-through;')
       jQuery('.product__price.on-sale').hide().attr('style','display:none !important;')
    } else {
      console.log ('**no hide mixed up prices')
    }

    setTimeout("jQuery('.discountedpricepp').css('font-size','15px !important').attr('style','font-size:15px !important;')",500)
    
}

function breadCrumbGen(referrer) {
  console.log('breadCrumbGen | referrer'+referrer)
  var breadcrumbhtml = ''
  var possibleLinks = []
  
  jQuery('.site-navigation .site-nav--has-dropdown').each(function() {
      var toptext = jQuery.trim(jQuery(this).find('a.site-nav__link--has-dropdown').attr('href'))
      if(toptext != '/collections/brands') {
        jQuery(this).find('.site-nav__dropdown-link').each(function() {
          var textname = jQuery.trim(jQuery(this).text())
          var texturl = jQuery.trim(jQuery(this).attr('href'))

          if(jQuery.inArray(texturl,setCollections) !== -1) {
           possibleLinks.push({'name':textname,'url':texturl})
          }
        });
      }
  });
  

  if(referrer != '') {
   // console.log('trying referrer')
    var possibleLinkName = jQuery.trim(jQuery('.site-nav a[href="'+referrer+'"]').text())
    var possibleLinkUrl = referrer

    var linky = jQuery('.header-item--navigation a[href="'+possibleLinkUrl+'"]')
    var link = jQuery('.header-item--navigation a[href="'+possibleLinkUrl+'"]').closest('.site-nav--has-dropdown').find('.site-nav__link--has-dropdown')
    jQuery(link).addClass('activelink')
    jQuery(linky).addClass('activelink')

    var linktext = jQuery.trim(jQuery(link).text())
    var linkurl = jQuery.trim(jQuery(link).attr('data-link'))
    console.log('trying referrer' +possibleLinkName)
    if(linktext != possibleLinkName) {
      if(linktext != '') {
        breadcrumbhtml = '<ol class="breadcrumbs 1a"><li class="breadcrumbs__item"><a href="/">Home</a></li><li class="breadcrumbs__item"><a href="'+linkurl+'">'+linktext+'</a></li><li class="breadcrumbs__item"><a href="'+possibleLinkUrl+'">'+possibleLinkName+'</a> <span class="currentbreadcrumbarrow"></span></li><li class="breadcrumbs__item"><a href="" class="currentbreadcrumb" aria-current="page">'+jQuery('.product-single__title ').text()+'</a></li> </ol>'
      } else {
        breadcrumbhtml = '<ol class="breadcrumbs 1b"><li class="breadcrumbs__item"><a href="/">Home</a></li><li class="breadcrumbs__item"><a href="'+possibleLinkUrl+'">'+possibleLinkName+'</a></li><li class="breadcrumbs__item"><span class="currentbreadcrumbarrow">></span></li><li class="breadcrumbs__item"><a href="" class="currentbreadcrumb" aria-current="page">'+jQuery('.product-single__title ').text()+'</a></li> </ol>'
      }
	    
    }
  }
  
  if(breadcrumbhtml == '') {
    jQuery(possibleLinks).each(function(i,possibleLink) {
      	if(breadcrumbhtml == '') {
		//console.log('referrrer didnt work')
          var possibleLinkName = possibleLink.name
          var possibleLinkUrl = possibleLink.url

          var linky = jQuery('a[href="'+possibleLink.url+'"]')
          var link = jQuery('a[href="'+possibleLink.url+'"]').closest('.site-nav--has-dropdown').find('.site-nav__link--has-dropdown')
          jQuery(link).addClass('activelink')
          jQuery(linky).addClass('activelink')
          
          var mobilelinky = jQuery('.mobile-nav__child-item a[href="'+possibleLink.url+'"]')
          var mobilelink = jQuery('.mobile-nav__child-item a[href="'+possibleLink.url+'"]').closest('.mobile-nav__sublist').prev().find('.mobile-nav__link')
          jQuery(mobilelinky).addClass('activelink')
          jQuery(mobilelink).addClass('activelink')

          var linktext = jQuery.trim(jQuery(link).text())
          var linkurl = jQuery.trim(jQuery(link).attr('href'))

          breadcrumbhtml = '<ol class="breadcrumbs 1c"><li class="breadcrumbs__item"><a href="/">Home</a></li><li class="breadcrumbs__item"> <a href="'+linkurl+'">'+linktext+'</a> </li><li class="breadcrumbs__item"><a href="'+possibleLink.url+'">'+possibleLink.name+'</a></li><li class="breadcrumbs__item"> <a href="" class="currentbreadcrumb" aria-current="page">'+jQuery('.product-single__title ').text()+'</a></li> </ol>'
        }
    });
  }
  
  if(breadcrumbhtml != '') {
	  jQuery('#breadcrumbs').html(breadcrumbhtml)
  }
}

function checkObsoleteandDates() {
  //maybe party-299 or 298 - but no created dates found so leaving this for future use
  
}

function reorderMattresses() {
	//console.log('reorderMattresses')
	var sizearray = []
	jQuery('.variant-input-wrap[name="Size"] .variant-input').each(function() {
	 sizearray.push(jQuery(this).attr('data-value'))
	});
	var sizeapplicable = false
	jQuery(sizearray).each(function() {
	 if($.inArray(sizearray, 'Full') == -1 || $.inArray(sizearray, 'Twin') == -1 || $.inArray(sizearray, 'Queen') == -1 || $.inArray(sizearray, 'King') == -1) {
		sizeapplicable = true 
	 }
	});
	//console.log('sizeapplicable '+sizeapplicable);
	 if(sizeapplicable == true) {
		 var ordering = 1
		 jQuery('.variant-input-wrap[name="Size"] .variant-input').each(function() {
		 if(jQuery(this).attr('data-value') == 'Twin') {
			jQuery(this).attr('data-sort','1'); ordering++
		 }
		 else if(jQuery(this).attr('data-value') == 'Full') {
			jQuery(this).attr('data-sort','2'); ordering++
		 }
		 else if(jQuery(this).attr('data-value') == 'Queen') {
			jQuery(this).attr('data-sort','3'); ordering++
		 }
		 else if(jQuery(this).attr('data-value') == 'King') {
			jQuery(this).attr('data-sort','4'); ordering++
		 } else {
			 jQuery(this).attr('data-sort','99');
		 }
		 });
																	
		var divList = jQuery('.variant-input-wrap[name="Size"] .variant-input');
		divList.sort(function(a, b){
			return jQuery(a).data("sort")-$(b).data("sort")
		});
		jQuery('.variant-input-wrap[name="Size"]').html(divList);
	 
	 }
 jQuery('.variant-input-wrap[name="Size"]').show();
}

function sortOutOptionLoad() {
	console.log('sortOutOptionLoad')
	var url = window.location.href;

	if(url.indexOf('variant=') > -1) {
		console.log('loading a VARIANT')

		//we need to know the selected variant id
		var selectedVariant = url.substr(url.indexOf("variant=") + 8)
        selectedVariant = selectedVariant.split('&')[0]

	} else {
		if(getVariants != undefined) {
          	//check to see if they're avaiable = true.. first one that is, gets the page load
          var selectedVariant = ''
          jQuery(getVariants).each(function(i,variant) {
            if(variant.available == true && selectedVariant == '') {
              selectedVariant = variant.id
            }
          })
        } 
		else {
			var selectedVariant = ''
		}
	}

  //https://dorelhome.atlassian.net/browse/PARTY-526
  //if colors and sizes... when a color has no size available disable it
  var optionsInventory = []
  jQuery(setVariants).each(function(i,detail) {
      var color = detail.color
      var inventory = jQuery('.variant-input[data-value="'+color+'"]').attr('data-inventory')
    if(inventory == undefined) {
      var newinventory = detail.inventory
    } else {
        var newinventory = parseInt(inventory) + parseInt(detail.inventory)
    }
    
   jQuery('.variant-input[data-value="'+color+'"]').attr('data-inventory',newinventory)
    if(newinventory > 0) {
      jQuery('.variant-input[data-value="'+color+'"] input, .variant-input[data-value="'+color+'"] label').removeClass('disabled')
    }
  });

  //hide any with no inventory
  jQuery('.variant-input[data-inventory="0"]').each(function() {
      //but allow it to be shown IF it's the default or loaded by the user directly
    if(jQuery(this).find('input').is(':checked')) {
      jQuery(this).show()
    } else {
      jQuery(this).hide()
    }
  })
  
  
// Add to the selectCallback function, or whichever function handles variant selection
// update turnTo reviews
  //console.log(window.TurnToSKUSetup)
  if(window.TurnToSKUSetup == "SKU") {
    //console.log('TurnToSKUSetup '+selectedVariant)
    TurnToCmd('set', {sku: selectedVariant});
  } else if(window.TurnToSKUSetup == "VARIANT") {
     //console.log('TurnToSKUSetup else '+selectedVariant)
    //TurnToCmd('set', {sku: selectedVariant});
  } else if(window.TurnToSKUSetup == "PRODUCT") {
    // do nothing;
     //console.log('TurnToSKUSetup else product '+selectedVariant)
  }

  //need to trim if there are any other url items
  
  
	//console.log('selectedVariant '+selectedVariant)
	//have to test to make sure we even have options
	//note: the getOptions != 'Title' test might just be bad data... but it's on a product so i'm setting it up for it
	if(getOptionsCount > 0 && getOptions != 'Title') {
		jQuery(getVariants).each(function(i,variant) {
	
		if(variant.id == selectedVariant) {

			//console.log(variant)

			//console.log('variant.sku '+variant.sku)
			//have to change values based on the variant specfic info
			if(variant.sku && variant.sku !='') {
    			jQuery('#variantSKU').text('SKU: '+variant.sku);
			}
			jQuery(setVariants).each(function(i,detail) {
              	//console.log(detail)
				if(detail.id == selectedVariant) {
    				//console.log('variant.sku '+variant.sku)
    				//Dimensions check
                    //need to test if dimensions array is actually an object... as the data is sometimes sent or set incorrectly as a string.
    				if(detail.dimensions[0].item_dims) {
                        var dimensionsArray = detail.dimensions[0].item_dims
                        if(typeof dimensionsArray === 'object') {
                            if(detail.dimensions[0].item_dims.depth > 0 && detail.dimensions[0].item_dims.depth !='') {
        					jQuery('#variantDims').text('Dimensions: '+detail.dimensions[0].item_dims.depth+ ' in. x '+ detail.dimensions[0].item_dims.height+' in. x '+detail.dimensions[0].item_dims.width+' in').show()
        					} else { 
        					jQuery('#variantDims').hide();
        					}
                        } else {
                            var dimensionsArrayString = JSON.parse(detail.dimensions[0].item_dims)
        					if(dimensionsArrayString.depth > 0 && dimensionsArrayString.depth !='') {
        					jQuery('#variantDims').text('Dimensions: '+dimensionsArrayString.depth+ ' in. x '+ dimensionsArrayString.height+' in. x '+dimensionsArrayString.width+' in.').show()
        					} else { 
        					jQuery('#variantDims').hide();
        					}
                        }
    				}
    			
    				//Shipping check

                    //need to test if dimensions array is actually an object... as the data is sometimes sent or set incorrectly as a string.
    				if(detail.dimensions[0].ship_dims) {
                        var shippingArray = detail.dimensions[0].ship_dims
                        if(typeof shippingArray === 'object') {
                            if(detail.dimensions[0].ship_dims.ship_depth > 0 && detail.dimensions[0].ship_dims.ship_depth !='') {
        					jQuery('#variantShip').text('Shipping: '+detail.dimensions[0].ship_dims.ship_depth+ ' in. x '+ detail.dimensions[0].ship_dims.ship_height+' in. x '+detail.dimensions[0].ship_dims.ship_width+' in').show()
        					} else { 
        					jQuery('#variantShip').hide();
        					}
                        } else {
                            var shippingArrayString = JSON.parse(detail.dimensions[0].ship_dims)
        					if(shippingArrayString.ship_depth > 0 && shippingArrayString.ship_depth !='') {
        					jQuery('#variantShip').text('Shipping: '+shippingArrayString.ship_depth+ ' in. x '+ shippingArrayString.ship_height+' in. x '+shippingArrayString.ship_width+' in.').show()
        					} else { 
        					jQuery('#variantShip').hide();
        					}
                        }
    				}
    
    				//Unit Weight check
    				if(detail.dimensions[0].unit_weight ) {
    					if(detail.dimensions[0].unit_weight > 0 && detail.dimensions[0].unit_weight	!='') {
    					jQuery('#variantWeight').text('Unit Weight : '+detail.dimensions[0].unit_weight + ' lbs').show()
    					} else { 
    					jQuery('#variantWeight').hide();
    					}
    				}
    			 
    				//Carton Weight check
    				if(detail.dimensions[0].carton_weight ) {
    					if(detail.dimensions[0].carton_weight	 !='') {
    					jQuery('#variantCarton').text('Carton Weight : '+detail.dimensions[0].carton_weight	+ ' lbs').show()
    					} else { 
    					jQuery('#variantCarton').hide();
    					}
    				}
    
                    //Collection check
    				if(detail.details[0].collection ) {
    					if(detail.details.collection	 !='') {
    					jQuery('#variantCollection').text('Collection : '+detail.details.collection).show()
    					} else { 
    					jQuery('#variantCollection').hide();
    					}
    				}
    
                      
                    //Primary Material Composition check PARTY-353
    				if(detail.composition[0].primary_material  ) {
    					if(detail.composition[0].primary_material !='') {
    						jQuery('#variantMaterial').text('Primary Material: '+detail.composition[0].primary_material ).show()
    					} else { 
    						jQuery('#variantMaterial').hide();
    					}
    				}
    
                      
                      if(detail.composition[0].fabric ) {
    					if(detail.composition[0].fabric !='') {
    						jQuery('#variantFabric').text('Primary Fabric: '+detail.composition[0].fabric).show()
    					} else { 
    						jQuery('#variantFabric').hide();
    					}
    				}
    
    
                    //Weight Limit variantWeightLimit check
                      //console.log(detail.seatdetails[0].weight_limit)
    				if(detail.seatdetails[0].weight_limit ) {
    					if(detail.seatdetails[0].weight_limit !='') {
    					jQuery('#variantWeightLimit').text('Weight Limit : '+detail.seatdetails[0].weight_limit	+ ' lbs').show()
    					} else { 
    					jQuery('#variantWeightLimit').hide();
    					}
    				}
    
                      //Seating Capacity check
    				if(detail.seatdetails[0].seating_capacity ) {
    					if(detail.seatdetails[0].seating_capacity !='') {
    					jQuery('#variantSeatingCapacity').text('Seating Capacity : '+detail.seatdetails[0].seating_capacity).show()
    					} else { 
    					jQuery('#variantSeatingCapacity').hide();
    					}
    				}
    
                       //Chair Height seat_details.chair_height check
    				if(detail.seatdetails[0].chair_height ) {
    					if(detail.seatdetails[0].chair_height !='') {
    					jQuery('#variantChairHeight').text('Chair Height : '+detail.seatdetails[0].chair_height	+ ' in.').show()
    					} else { 
    					jQuery('#variantChairHeight').hide();
    					}
    				}
    
                      //Chair Height seat_details.chair_depth check
    				if(detail.seatdetails[0].chair_depth ) {
    					if(detail.seatdetails[0].chair_depth !='') {
    					jQuery('#variantChairDepth').text('Chair Depth : '+detail.seatdetails[0].chair_depth	+ ' in.').show()
    					} else { 
    					jQuery('#variantChairDepth').hide();
    					}
    				}
    
                       //Seatback Height seatdetails.seatback_height check
    				if(detail.seatdetails[0].seatback_height ) {
    					if(detail.seatdetails[0].seatback_height !='') {
    					jQuery('#variantSeatbackHeight').text('Seatback Height : '+detail.seatdetails[0].seatback_height	+ ' in.').show()
    					} else { 
    					jQuery('#variantSeatbackHeight').hide();
    					}
    				}
    
                      //Cushion Thickness seatdetails.cushion_thickness check
    				if(detail.seatdetails[0].cushion_thickness ) {
    					if(detail.seatdetails[0].cushion_thickness !='') {
    					jQuery('#variantCushion').text('Cushion Thickness : '+detail.seatdetails[0].cushion_thickness	+ ' in.').show()
    					} else { 
    					jQuery('#variantCushion').hide();
    					}
    				}
    
    
                      //Table Seats tabledetails.table_seats check
    				if(detail.tabledetails[0].table_seats ) {
    					if(detail.tabledetails[0].table_seats !='') {
    					jQuery('#variantTableSeats').text('Table Seats : '+detail.tabledetails[0].table_seats).show()
    					} else { 
    					jQuery('#variantTableSeats').hide();
    					}
    				}
    
                      //Tabletop Thickness tabledetails.table_seats check
    				if(detail.tabledetails[0].tabletop_thickness ) {
    					if(detail.tabledetails[0].tabletop_thickness !='') {
    					jQuery('#variantTableThickness').text('Tabletop Thickness : '+detail.tabledetails[0].tabletop_thickness).show()
    					} else { 
    					jQuery('#variantTableThickness').hide();
    					}
    				}
    
                      //Box Spring Required beddetails.box_spring_required check
    				if(detail.beddetails[0].box_spring_required ) {
    					if(detail.beddetails[0].box_spring_required	!='') {
    					jQuery('#variantBoxSpring').text('Box Spring Required : '+detail.beddetails[0].box_spring_required).show()
    					} else { 
    					jQuery('#variantBoxSpring').hide();
    					}
    				}
    
                      //Number of Shelves Required details.number_of_shelves check
    				if(detail.details[0].number_of_shelves ) {
    					if(detail.details[0].number_of_shelves !='') {
    					jQuery('#variantShelves').text('Number of Shelves : '+detail.details[0].number_of_shelves).show()
    					} else { 
    					jQuery('#variantShelves').hide();
    					}
    				}
    
                      //Release Date Required details.initiation_date check
    				if(detail.details[0].initiation_date ) {
    					if(detail.details[0].initiation_date !='') {
    					jQuery('#variantReleaseDate').text('Release Date : '+detail.details[0].initiation_date).show()
    					} else { 
    					jQuery('#variantReleaseDate').hide();
    					}
    				}
    
                      //Prop 65 Warning compliance.prop_65_required check
                      if(detail.compliance[0].prop_65_required ) {
                        if(detail.compliance[0].prop_65_required == 'Yes') {
            				if(detail.compliance[0].prop65_warning ) {
            					if(detail.compliance[0].prop65_warning !='') {
                					jQuery('#variantProp65').text('Prop 65 Warning : '+detail.compliance[0].prop65_warning).show()
            					} else { 
            					jQuery('#variantProp65').hide();
            					}
            				}
                        }
                      }
                      
    
                       //Release Date Required details.initiation_date check
    				if(detail.compliance[0].tip_warning ) {
    					if(detail.compliance[0].tip_warning !='') {
    					jQuery('#variantTipWarning').text('Tip Warning : '+detail.compliance[0].tip_warning).show()
    					} else { 
    					jQuery('#variantTipWarning').hide();
    					}
    				}
    
                      
    
                      
                      
    
    			
    				//Assembly Manual check - requires check for if the field is present, if the field is JSON correctly (old way) or a string of JSON that needs to be parsed
    				var assemblyinfo = detail.documents[0].assembly_url
    				if(assemblyinfo !='' && assemblyinfo != undefined) {
    					if(assemblyinfo.indexOf('{') >-1 ) {
    						var assemblyhtml = ''
    						var parsedassembly = $.parseJSON(assemblyinfo);
    						var visiblecount = 0
        					jQuery(parsedassembly).each(function(i, item) {
        						if(item.type == '1') { visiblecount++; assemblyhtml+= '<li><a href="'+item.url+'" target="_blank" title="'+item.title+'"><i class="fa fa-file-pdf"></i> Assembly Manual</a></li>' 
        						//} else if(item.type == '2') { assemblyhtml+= '<li><a href="'+item.url+'" target="_blank" title="'+item.title+'"><i class="fa fa-file-pdf"></i>Care Instructions</a></li>' 
        						//} else if(item.type == '3') { assemblyhtml+= '<li><a href="'+item.url+'" target="_blank" title="'+item.title+'"><i class="fa fa-file-pdf"></i>Schematics with Dimensions</a></li>' 
        						//} else if(item.type == '4') { assemblyhtml+= '<li><a href="'+item.url+'" target="_blank" title="'+item.title+'"><i class="fa fa-file-pdf"></i>Warranty</a></li>' 
        						//} else if(item.type == '5') { assemblyhtml+= '<li><a href="'+item.url+'" target="_blank" title="'+item.title+'"><i class="fa fa-file-pdf"></i>What\'s in the Box</a></li>' 
        						//} else if(item.type == '21') { assemblyhtml+= '<li><a href="'+item.url+'" target="_blank" title="'+item.title+'"><i class="fa fa-file-pdf"></i>Line Art</a></li>' 
        						//} else if(item.type == '26') { visiblecount++; assemblyhtml+= '<li><a href="'+item.url+'" target="_blank" title="'+item.title+'"><i class="fa fa-file-pdf"></i> Functional Drawings</a></li>' 
        						//} else if(item.type == '35') { assemblyhtml+= '<li><a href="'+item.url+'" target="_blank" title="'+item.title+'"><i class="fa fa-file-pdf"></i>Assembly Manual Corrections</a></li>' 
        						} //else { assemblyhtml+= '<li><a href="'+item.url+'" target="_blank"><i class="fa fa-file-pdf"></i> '+item.title+' '+item.type+'</a></li>' }
        					});
        					if(visiblecount > 0) {
        						jQuery('#variantAssembly').html('Documents:<ul id="assemblyUL">'+assemblyhtml+'</ul>').show()
        					} else {
        						jQuery('#variantAssembly').hide();
        					}
        				} else {
        					jQuery('#variantAssembly').html('Documents: <ul id="assemblyUL"><li><a href="'+assemblyinfo+'" target="_blank"><i class="fa fa-file-pdf"></i> Assembly Manual</a></li></ul>').show()
        				}
    				} else { 
    					//console.log('nothing here')
    					jQuery('#variantAssembly').hide();
    				}
    
    				//Parts check
    				if(detail.documents[0].parts_url !='' && detail.documents[0].parts_url != undefined) {
    					jQuery('#variantParts').html('<a href="'+detail.documents[0].parts_url+'" target="_blank"><i class="fa fa-file-pdf"></i> Parts Manual</a>').show()
    				} else { 
    					jQuery('#variantParts').hide();
    				}
    			
    				//Features check
                    //console.log('features length ')
                    //console.log(detail.features[0].features == undefined)
    				if(detail.features[0].features != undefined) {
        			  var featuresArray = detail.features[0].features
                      //need to test if Features array is actually an object... as the data is sometimes sent or set incorrectly as a string.
                       if(typeof featuresArray === 'object') {
    					if(featuresArray.features_01 !='') {
        					var featuresList = ''
        					for (variable in featuresArray) {
        						featuresList+='<li>'+featuresArray[variable]+'</li>'
        					}
        					jQuery('#featuresList').html(featuresList)
    					}
                       } else {
                          var featuresArrayBad = detail.features[0].features
                          var featuresArrayString = JSON.parse(featuresArrayBad)
                         if(featuresArrayString.features_01 !='') {
        					var featuresList = ''
        					for (variable in featuresArrayString) {
        						featuresList+='<li>'+featuresArrayString[variable]+'</li>'
        					}
        					jQuery('#featuresList').html(featuresList)
    					 }
                       }
                    } else {
                     //console.log('no features') 
                    }
    			
    
    			
    			//Media check
    			jQuery('#videoList, #videoList-Mobile').html('')
    			if(detail.media[0].videos) {
    				var mediaraw = detail.media[0].videos
    				var mediaArray = $.parseJSON(mediaraw);
    				//console.log('mediaArray')
    				//console.log(mediaArray)
    				if(mediaArray !='') {
    				var videoList = ''
    				var videocount = 0
    				jQuery(mediaArray).each(function (i,video) {
    					//get the video id from the video.url
    					var vidurl = video.url
    					//console.log(vidurl)
    			
    					if(vidurl.indexOf('youtube') > -1 || vidurl.indexOf('youtu.be') > -1) {
    						if(vidurl.indexOf('youtube') > -1) {
                              	if(vidurl.indexOf('/v/') > -1) {
                                var vidid = vidurl.split('/v/')[1];
                              } else if(vidurl.indexOf('watch?v=') > -1) {
                                var vidid = vidurl.split('watch?v=')[1];
                              } else {
                                var vidid = vidurl.split('/embed/')[1];
                              }
    
    						  
    						} else if(vidurl.indexOf('youtu.be') > -1) {
    						  var vidid = vidurl.split('youtu.be/')[1];
    						}
    						console.log('vidid '+vidid)
                            if(vidid.indexOf('&feature') > -1) {
    						  vidid = vidid.split('&feature')[0];
    						}
                          console.log('vidid '+vidid)
                          
                          jQuery('#videoList').append('<li style="vertical-align:top;"><a class="videopopuploadyoutube" href="https://www.youtube.com/watch?v='+vidid+'"  id="video'+videocount+'" video-url="https://www.youtube.com/watch?v='+vidid+'" data-video-id="'+vidid+'" data-lity><img src="https://img.youtube.com/vi/'+vidid+'/hqdefault.jpg" /><br>'+video.title+'</a></li>')
    						//jQuery('.videopopupload').videoPopup();
    
    						jQuery('#videoList-Mobile').append('<li  style="vertical-align:top;"><a class="videopopuploadyoutube" href="https://www.youtube.com/watch?v='+vidid+'" id="video-mobile'+videocount+'" video-url="https://www.youtube.com/watch?v='+vidid+'" data-video-id="'+vidid+'" data-lity><img src="https://img.youtube.com/vi/'+vidid+'/hqdefault.jpg" /><br>'+video.title+'</a></li>')
    						//jQuery('#video-mobile'+videocount).videoPopup();
    					} else if(vidurl.indexOf('vimeo') > -1) {
                          
                           if(vidurl.indexOf('video') > -1) {
                             vidurl = vidurl.replace(new RegExp("video/", "g"), '')
                             } 
                          
                          var vidid = vidurl.split('.com/')[1];
    							//console.log('in vimeo '+vidid)
    							$.ajax({
    								url: 'http://vimeo.com/api/v2/video/'+vidid+'.json',
                                  //url: 'http://vimeo.com/api/v2/video/'+vidid+'.json',
    								type: 'GET',
    								dataType: 'JSON',
    								success: function(data) {
    									//console.log(data)
    									jQuery('#videoList').append('<li  style="vertical-align:top;"><a class="videopopuploadvimeo" href="https://vimeo.com/'+vidid+'" id="video'+videocount+'" video-url="https://vimeo.com/'+vidid+'" data-video-id="'+vidid+'" data-lity ><img src="'+data[0].thumbnail_medium+'" /><br>'+video.title+'</a></li>')
    									//jQuery('#video'+videocount).videoPopup();
    				
    									jQuery('#videoList-Mobile').append('<li  style="vertical-align:top;"><a class="videopopuploadvimeo" href="https://vimeo.com/'+vidid+'" id="video-mobile'+videocount+'" video-url="https://vimeo.com/'+vidid+'" data-video-id="'+vidid+'" data-lity ><img src="'+data[0].thumbnail_medium+'" /><br>'+video.title+'</a></li>')
    									//jQuery('#video-mobile'+videocount).videoPopup();
    								}
    							});
    						}
    						videocount++
    					});
    					jQuery('#videoList, #videoList-Mobile').show();
    					jQuery('#videoListTitle, #videoList-MobileTitle').show();
    				} else { 
    					//may not replace this one, so not hiding for now
    					jQuery('#videoList, #videoList-Mobile').hide();
    					jQuery('#videoListTitle, #videoList-MobileTitle').hide();
    				}
                  
    
    			}
    			}
    		})
    
    			variantOptions = variant.options
    			thumbnails.each(function() {
    				var thisalttag = jQuery(this).attr('alt')
    				//lets remove the title from the alt value
    				//var thisaltOptions = thisalttag.replace(baseTitle,'');
    				//console.log('thisaltOptions '+thisaltOptions)
    
    				var thisaltTitle = thisalttag.substring(thisalttag.indexOf(" - ") + 3);
    				var thisindex = jQuery(this).closest('.product__thumb-item').attr('data-index')
    				//console.log(thisindex)
    				var thisaltOptions = thisaltTitle.split(' - ')
    				//console.log('thisaltOptions '+thisaltOptions)
    				var thisaltCounter = 0;
    
    				jQuery(thisaltOptions).each(function (i,option) {
    					if(variantOptions.includes(option)) {
    					//console.log('good option: '+option)
    					 thisaltCounter++
    					} else {
    					//console.log('bad option: '+option) 
    					}
    				});
    				//now that we can see if they're valid or not, show/hide
    				if(thisaltCounter >= getOptionsCount) {
    					jQuery(this).closest('.product__thumb-item').addClass('correctmodel').removeClass('notcorrectmodel')
    				} else {
    					 jQuery(this).closest('.product__thumb-item').addClass('notcorrectmodel').removeClass('correctmodel')
    				}
    			});
              
              //failsafe
              if(jQuery('.correctmodel').length == 0) {
                //console.log('thumbnail failsafe triggered')
                jQuery('.notcorrectmodel').addClass('correctmodel').removeClass('notcorrectmodel')
              } 
    		}
		});
	} else {
		//console.log('show them all!')
		thumbnails.each(function() {
		var thisindex = jQuery(this).closest('.product__thumb-item').attr('data-index')
		jQuery(this).closest('.product__thumb-item').addClass('correctmodel')
		})
	}
  
  testVideoLength()
  setTimeout('testVideoLength()',500);
  
//Adding this back in so when the page loads it shows the correct active variant in the image/thumbnails
  setTimeout("jQuery('.product__thumb-item.correctmodel').first().find('img').trigger('click')" ,500);

  handleDiscountedPrices()
  
} //close out function sortOutOptionLoad

function removeSingleImages() {
  //console.log('removeSingleImages')
  jQuery('.variant-wrapper--button').each(function() {
    //see if we have anything besides N/A
    var notna = ''
    jQuery(this).find('.variant-input input').each(function() {
     // console.log(jQuery(this).val())
      if(jQuery(this).val() != 'N/A') {
        notna += jQuery(this).val()
      }
    });
    
    if(notna != '') {
      	//console.log('show')
     	jQuery(this).show() 
    } else {
      	//console.log('hide')
    }
  });
  
}

function handleSingleVariantDisplay() {
  //console.log('handleSingleVariantDisplay')
  jQuery('.variant-wrapper--button').each(function() {
    //see if we have anything besides N/A
    var notna = ''
    jQuery(this).find('.variant-input input').each(function() {
     // console.log(jQuery(this).val())
      if(jQuery(this).val() != 'N/A') {
        notna += jQuery(this).val()
      }
    });
    
    if(notna != '') {
      	//console.log('show')
     	jQuery(this).show() 
        jQuery(this).trigger('click')
    } else {
      	//console.log('hide')
    }
  });
  
}

function testVideoLength() {
               if(jQuery('#videoList li').length > 0) {
              	jQuery('#videoList, #videoList-Mobile').show();
				jQuery('#videoListTitle, #videoList-MobileTitle').show();
              } else {
                jQuery('#videoList, #videoList-Mobile').hide();
				jQuery('#videoListTitle, #videoList-MobileTitle').hide();
              } 

  //jQuery('.videopopuploadyoutube').modalVideo({channel:'youtube'});
 //jQuery('.videopopuploadvimeo').modalVideo({channel:'vimeo'});
  
}
function sortOutOptionDisable(value,dataoption) {
	//console.log('in sortOutOptionDisable | value:'+ value+' dataoption '+dataoption)
	//kinda hack to get this work for 2 options

	var option0 = jQuery('#ProductSelect-product-template-option-0 option:selected').val();
	var option1 = jQuery('#ProductSelect-product-template-option-1 option:selected').val();

	//since option1 has to be right from the start and should never be disabled, we got to option2
	jQuery('#ProductSelect-product-template-option-1 option').prop('disabled',true)
	jQuery(getVariants).each(function(i,variant) {
		if(variant.options[0] == option0) {
			jQuery('#ProductSelect-product-template-option-1 option[value="'+variant.options[1]+'"]').prop('disabled',false)
		} else {
			//we're looking at other variant values 
		}
	});

	//if after change, we see the variant hasn't change, we know there's a problem...
	var url = window.location.href;
	var urlVariant = url.substr(url.indexOf("variant=") + 8)
	if(jQuery('#ProductSelect-product-template-option-1 option:selected').is(':disabled')) {
		//if(setProductId == urlVariant) {
		jQuery('#ProductSelect-product-template-option-1').children('option:enabled').eq(0).prop('selected',true);
		jQuery('#ProductSelect-product-template-option-1').trigger('change')
	}
	setProductId = urlVariant

    //https://dorelhome.atlassian.net/browse/PARTY-526
    var activecount = 0
    jQuery('.variant-input[data-index="option2"] label:visible').each(function() {
      if(jQuery(this).prev().is(':checked')) {
        activecount++
      }
    })
    if(activecount == 0) {
      jQuery('.variant-input[data-index="option2"] label:visible:first').prev().trigger('click')
    }
}



//PIMS-3532 forcing product titles to be the same height
function setheight() {
	jQuery('.grid-product__title').css('min-height','30px');
	var setheight = 30
	jQuery('.grid-product__title').each(function() {
		if(jQuery(this).height() > setheight) {
		 setheight = jQuery(this).height(); 
		}
	});
	//console.log(setheight)
	jQuery('.grid-product__title').css('min-height',setheight+'px');
	jQuery('.grid-product__colors, .grid-product__price').css('opacity','1');
}